<template>
  <div class="m-card-primary m-initial-setup">
    <p>Initial Setup</p>
  </div>
</template>

<script>
export default {
  name: 'MoleculeInitialSetup'
}
</script>
